// src/lib/translations.ts

export const translations = {
  gameOverview: {
    title: {
      en: "overview",
      ja: "概要",
      ko: "개요",
      th: "ภาพรวม",
      es: "resumen",
      ru: "обзор",
      vi: "tổng quan",
      kk: "шолу",
      id: "ikhtisar",
      uk: "огляд"
    },
    whyPlay: {
      en: "Why Play",
      ja: "なぜプレイするのか",
      ko: "왜 플레이해야 하나요",
      th: "ทำไมต้องเล่น",
      es: "Por qué jugar",
      ru: "Почему стоит играть",
      vi: "Tại sao chơi",
      kk: "Неге ойнау керек",
      id: "Mengapa bermain",
      uk: "Чому варто грати"
    }
  },
  gameplayGuide: {
    title: {
      en: "How to play",
      ja: "遊び方",
      ko: "게임 방법",
      th: "วิธีการเล่น",
      es: "Cómo jugar",
      ru: "Как играть",
      vi: "Cách chơi",
      kk: "Қалай ойнау керек",
      id: "Cara bermain",
      uk: "Як грати"
    },
    removeBlocks: {
      en: "MiSide Mita",
      ja: "MiSide Mita",
      ko: "MiSide Mita",
      th: "MiSide Mita",
      es: "MiSide Mita",
      ru: "MiSide Mita",
      vi: "MiSide Mita",
      kk: "MiSide Mita",
      id: "MiSide Mita",
      uk: "MiSide Mita"
    }
  },
  scoringSystem: {
    title: {
      en: "How to calculate points",
      ja: "ポイントの計算方法",
      ko: "점수 계산 방법",
      th: "วิธีคำนวณคะแนน",
      es: "Cómo calcular puntos",
      ru: "Как подсчитать очки",
      vi: "Cách tính điểm",
      kk: "Ұпай есептеу",
      id: "Cara menghitung poin",
      uk: "Як підрахувати очки"
    },
    basicScore: {
      en: "Basic score",
      ja: "基本スコア",
      ko: "기본 점수",
      th: "คะแนนพื้นฐาน",
      es: "Puntuación básica",
      ru: "Базовые очки",
      vi: "Điểm cơ bản",
      kk: "Негізгі ұпай",
      id: "Skor dasar",
      uk: "Базові очки"
    }
  },
  tutorials: {
    title: {
      en: "Tutorial Videos from Youtube",
      ja: "YouTubeのチュートリアル動画",
      ko: "YouTube 튜토리얼 동영상",
      th: "วิดีโอสอนจาก Youtube",
      es: "Videos tutoriales de Youtube",
      ru: "Обучающие видео с Youtube",
      vi: "Video hướng dẫn từ Youtube",
      kk: "Youtube-тен оқу видеолары",
      id: "Video Tutorial dari Youtube",
      uk: "Навчальні відео з Youtube"
    }
  },
  comments: {
    title: {
      en: "Comments",
      ja: "コメント",
      ko: "댓글",
      th: "ความคิดเห็น",
      es: "Comentarios",
      ru: "Комментарии",
      vi: "Bình luận",
      kk: "Пікірлер",
      id: "Komentar",
      uk: "Коментарі"
    },
    placeholders: {
      name: {
        en: 'Your name',
        ja: 'お名前',
        ko: '이름',
        th: 'ชื่อของคุณ',
        es: 'Tu nombre',
        ru: 'Ваше имя',
        vi: 'Tên của bạn',
        kk: 'Сіздің атыңыз',
        id: 'Nama Anda',
        uk: 'Ваше імʼя'
      },
      content: {
        en: 'Write a comment...',
        ja: 'コメントを書く...',
        ko: '댓글을 작성하세요...',
        th: 'เขียนความคิดเห็น...',
        es: 'Escribe un comentario...',
        ru: 'Написать комментарий...',
        vi: 'Viết bình luận...',
        kk: 'Пікір жазыңыз...',
        id: 'Tulis komentar...',
        uk: 'Напишіть коментар...'
      }
    },
    noComments: {
      en: "No comments yet. Be the first to comment!",
      ja: "まだコメントはありません。最初のコメントを投稿しましょう！",
      ko: "아직 댓글이 없습니다. 첫 댓글을 남겨보세요!",
      th: "ยังไม่มีความคิดเห็น เป็นคนแรกที่แสดงความคิดเห็น!",
      es: "Aún no hay comentarios. ¡Sé el primero en comentar!",
      ru: "Пока нет комментариев. Будьте первым, кто прокомментирует!",
      vi: "Chưa có bình luận nào. Hãy là người đầu tiên bình luận!",
      kk: "Әзірше пікірлер жоқ. Бірінші болып пікір қалдырыңыз!",
      id: "Belum ada komentar. Jadilah yang pertama berkomentar!",
      uk: "Поки немає коментарів. Будьте першим, хто прокоментує!"
    },
    sortBy: {
      newest: {
        en: "Newest",
        ja: "最新",
        ko: "최신순",
        th: "ใหม่ล่าสุด",
        es: "Más recientes",
        ru: "Новейшие",
        vi: "Mới nhất",
        kk: "Ең жаңа",
        id: "Terbaru",
        uk: "Найновіші"
      },
      oldest: {
        en: "Oldest",
        ja: "最古",
        ko: "오래된순",
        th: "เก่าที่สุด",
        es: "Más antiguos",
        ru: "Старейшие",
        vi: "Cũ nhất",
        kk: "Ең ескі",
        id: "Terlama",
        uk: "Найстаріші"
      }
    },
    submitButton: {
      en: 'Submit Comment',
      ja: 'コメントを投稿',
      ko: '댓글 작성',
      th: 'ส่งความคิดเห็น',
      es: 'Enviar comentario',
      ru: 'Отправить комментарий',
      vi: 'Gửi bình luận',
      kk: 'Пікір жіберу',
      id: 'Kirim Komentar',
      uk: 'Надіслати коментар'
    }
  },
  footer: {
    about: {
      title: {
        en: "About",
        ja: "について",
        ko: "소개",
        th: "เกี่ยวกับ",
        es: "Acerca de",
        ru: "О нас",
        vi: "Giới thiệu",
        kk: "Туралы",
        id: "Tentang",
        uk: "Про нас"
      },
      description: {
        en: 'Beneath its innocent facade, MiSide harbors dark secrets that gradually emerge, transforming the experience into something far more sinister!',
        ja: '無邪気な表面の下に、MiSideは徐々に姿を現す暗い秘密を秘めており、その体験はより不気味なものへと変貌していきます!',
        ko: '순수한 겉모습 아래, MiSide는 점차 드러나는 어두운 비밀을 품고 있어 경험이 점점 더 불길한 것으로 변모해갑니다!',
        th: 'ภายใต้ภาพลักษณ์ที่ไร้เดียงสา MiSide ซ่อนความลับอันมืดมนที่ค่อยๆ ปรากฏขึ้น เปลี่ยนประสบการณ์ให้กลายเป็นบางสิ่งที่น่าหวาดกลัวยิ่งขึ้น!',
        es: 'Bajo su fachada inocente, MiSide esconde oscuros secretos que emergen gradualmente, transformando la experiencia en algo mucho más siniestro!',
        ru: 'Под невинным фасадом MiSide таит темные секреты, которые постепенно всплывают на поверхность, превращая игру во что-то гораздо более зловещее!',
        vi: 'Dưới vẻ ngoài ngây thơ, MiSide chứa đựng những bí mật đen tối dần dần xuất hiện, biến trải nghiệm thành điều gì đó đáng sợ hơn nhiều!',
        kk: 'Қарапайым сыртқы келбетінің астында, MiSide біртіндеп пайда болатын қараңғы құпияларды жасырып, тәжірибені әлдеқайда қорқынышты нәрсеге айналдырады!',
        id: 'Di balik tampilan polosnya, MiSide menyimpan rahasia gelap yang perlahan muncul, mengubah pengalaman menjadi sesuatu yang jauh lebih mengerikan!',
        uk: 'Під невинним фасадом MiSide ховає темні таємниці, які поступово спливають на поверхню, перетворюючи досвід у щось набагато зловісніше!'
      }
    },
    quickLinks: {
      title: {
        en: "Quick Links",
        ja: "クイックリンク",
        ko: "빠른 링크",
        th: "ลิงก์ด่วน",
        es: "Enlaces rápidos",
        ru: "Быстрые ссылки",
        vi: "Liên kết nhanh",
        kk: "Жылдам сілтемелер",
        id: "Tautan Cepat",
        uk: "Швидкі посилання"
      },
      home: {
        en: "Home",
        ja: "ホーム",
        ko: "홈",
        th: "หน้าแรก",
        es: "Inicio",
        ru: "Главная",
        vi: "Trang chủ",
        kk: "Басты бет",
        id: "Beranda",
        uk: "Головна"
      },
      playNow: {
        en: "Play Now",
        ja: "今すぐプレイ",
        ko: "지금 플레이",
        th: "เล่นเลย",
        es: "Jugar ahora",
        ru: "Играть сейчас",
        vi: "Chơi ngay",
        kk: "Қазір ойнау",
        id: "Main Sekarang",
        uk: "Грати зараз"
      },
      tutorials: {
        en: "Tutorials",
        ja: "チュートリアル",
        ko: "튜토리얼",
        th: "บทเรียน",
        es: "Tutoriales",
        ru: "Учебники",
        vi: "Hướng dẫn",
        kk: "Оқулықтар",
        id: "Tutorial",
        uk: "Інструкції"
      },
      popularGames: {
        en: "Popular Games",
        ja: "人気ゲーム",
        ko: "인기 게임",
        th: "เกมยอดนิยม",
        es: "Juegos populares",
        ru: "Популярные игры",
        vi: "Trò chơi phổ biến",
        kk: "Танымал ойындар",
        id: "Game Populer",
        uk: "Популярні ігри"
      }
    },
    community: {
      title: {
        en: "Community",
        ja: "コミュニティ",
        ko: "커뮤니티",
        th: "ชุมชน",
        es: "Comunidad",
        ru: "Сообщество",
        vi: "Cộng đồng",
        kk: "Қауымдастық",
        id: "Komunitas",
        uk: "Спільнота"
      },
      discord: {
        en: "Discord",
        ja: "Discord",
        ko: "Discord",
        th: "Discord",
        es: "Discord",
        ru: "Discord",
        vi: "Discord",
        kk: "Discord",
        id: "Discord",
        uk: "Discord"
      },
      facebook: {
        en: "Facebook",
        ja: "Facebook",
        ko: "Facebook",
        th: "Facebook",
        es: "Facebook",
        ru: "Facebook",
        vi: "Facebook",
        kk: "Facebook",
        id: "Facebook",
        uk: "Facebook"
      },
      twitter: {
        en: "Twitter",
        ja: "Twitter",
        ko: "Twitter",
        th: "Twitter",
        es: "Twitter",
        ru: "Twitter",
        vi: "Twitter",
        kk: "Twitter",
        id: "Twitter",
        uk: "Twitter"
      },
      youtube: {
        en: "YouTube",
        ja: "YouTube",
        ko: "YouTube",
        th: "YouTube",
        es: "YouTube",
        ru: "YouTube",
        vi: "YouTube",
        kk: "YouTube",
        id: "YouTube",
        uk: "YouTube"
      }
    },
    contact: {
      title: {
        en: "Contact Us",
        ja: "お問い合わせ",
        ko: "문의하기",
        th: "ติดต่อเรา",
        es: "Contáctenos",
        ru: "Свяжитесь с нами",
        vi: "Liên hệ",
        kk: "Байланыс",
        id: "Hubungi Kami",
        uk: "Зв'яжіться з нами"
      },
      email: {
        en: "support@miside-mita.com",
        ja: "support@miside-mita.com",
        ko: "support@miside-mita.com",
        th: "support@miside-mita.com",
        es: "support@miside-mita.com",
        ru: "support@miside-mita.com",
        vi: "support@miside-mita.com",
        kk: "support@miside-mita.com",
        id: "support@miside-mita.com",
        uk: "support@miside-mita.com"
      },
      address: {
        en: "123 Game Street, Tokyo, Japan",
        ja: "〒123-4567 東京都渋谷区ゲーム通り1-2-3",
        ko: "123 게임 스트리트, 도쿄, 일본",
        th: "123 ถนนเกม โตเกียว ญี่ปุ่น",
        es: "123 Calle del Juego, Tokio, Japón",
        ru: "123 Улица Игр, Токио, Япония",
        vi: "123 Đường Game, Tokyo, Nhật Bản",
        kk: "123 Гейм көшесі, Токио, Жапония",
        id: "123 Jalan Game, Tokyo, Jepang",
        uk: "123 Вулиця Ігор, Токіо, Японія"
      }
    },
    links: {
      privacy: {
        en: 'Privacy Policy',
        ja: 'プライバシーポリシー',
        ko: '개인정보 처리방침',
        th: 'นโยบายความเป็นส่วนตัว',
        es: 'Política de privacidad',
        ru: 'Политика конфиденциальности',
        vi: 'Chính sách bảo mật',
        kk: 'Құпиялылық саясаты',
        id: 'Kebijakan Privasi',
        uk: 'Політика конфіденційності'
      },
      terms: {
        en: 'Terms of Service',
        ja: '利用規約',
        ko: '이용약관',
        th: 'ข้อกำหนดการใช้งาน',
        es: 'Términos de servicio',
        ru: 'Условия использования',
        vi: 'Điều khoản dịch vụ',
        kk: 'Қызмет көрсету шарттары',
        id: 'Ketentuan Layanan',
        uk: 'Умови використання'
      },
      cookies: {
        en: 'Cookie Policy',
        ja: 'Cookie ポリシー',
        ko: '쿠키 정책',
        th: 'นโยบายคุกกี้',
        es: 'Política de cookies',
        ru: 'Политика использования файлов cookie',
        vi: 'Chính sách cookie',
        kk: 'Cookie саясаты',
        id: 'Kebijakan Cookie',
        uk: 'Політика використання файлів cookie'
      }
    },
    copyright: {
      en: 'MiSide Mita. All rights reserved.',
      ja: 'MiSide Mita. 全著作権所有。',
      ko: 'MiSide Mita. 모든 권리 보유.',
      th: 'MiSide Mita. สงวนลิขสิทธิ์.',
      es: 'MiSide Mita. Todos los derechos reservados.',
      ru: 'MiSide Mita. Все права защищены.',
      vi: 'MiSide Mita. Tất cả các quyền được bảo lưu.',
      kk: 'MiSide Mita. Барлық құқықтар қорғалған.',
      id: 'MiSide Mita. Hak cipta dilindungi.',
      uk: 'MiSide Mita. Всі права захищені.'
    }
  },
  recommendedGames: {
    title: {
      en: 'Recommended Games',
      ja: 'おすすめゲーム',
      ko: '추천 게임',
      th: 'เกมแนะนำ',
      es: 'Juegos Recomendados',
      ru: 'Рекомендуемые игры',
      vi: 'Trò chơi đề xuất',
      kk: 'Ұсынылған ойындар',
      id: 'Game yang Direkomendasikan',
      uk: 'Рекомендовані ігри'
    }
  }
} as const;